class MemoryStorage implements Storage {
  #store: Map<string, string> = new Map();

  get length() {
    return this.#store.size;
  }

  key(n: number) {
    return this.#store.keys().find((_, i) => i === n) ?? null;
  }

  getItem(key: string) {
    return this.#store.get(key) ?? null;
  }

  setItem(key: string, value: string) {
    this.#store.set(key, value);
    return this;
  }

  removeItem(key: string) {
    this.#store.delete(key);
    return this;
  }

  clear() {
    this.#store.clear();
    return this;
  }
}

export default new MemoryStorage();
